// services/Database.web.js

export const initDB = async () => {};

export const syncFiyatlar = async (gelenVeri) => {
  try {
    localStorage.setItem('fiyatlar', JSON.stringify(gelenVeri));
    console.log(`✅ ${gelenVeri.length} adet fiyat localStorage'a işlendi.`);
  } catch (e) {
    console.log('syncFiyatlar web hata:', e);
  }
};

export const getFiyatlar = async () => {
  try {
    const data = localStorage.getItem('fiyatlar');
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.log('getFiyatlar web hata:', e);
    return [];
  }
};

export const syncPersonel = async (gelenVeri) => {
  try {
    localStorage.setItem('personel', JSON.stringify(gelenVeri));
    console.log(`✅ ${gelenVeri.length} personel localStorage'a işlendi.`);
  } catch (e) {
    console.log('syncPersonel web hata:', e);
  }
};

export const getPersonel = async () => {
  try {
    const data = localStorage.getItem('personel');
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.log('getPersonel web hata:', e);
    return [];
  }
};